import React, { useState, useEffect } from "react";
import { FixedDigitsInput, RejectionReason, SelectWithSearch, VerifyComponent } from "components";
import DatePickerInput from "components/datePicker";
import { getUserRoles } from "modules/auth/slice";
import { useSelector } from "react-redux";
import { FormRow, FormGroup, Row, Textarea } from "styles/forms/main";

function TruckInfo({
    newTruckData,
    setNewTruckData,
    allTruckClass,
    allBoxesType,
    isEditable,
    plateNumberError,
    selectedTruckId,
    isPlateNumberEditable,
    objections,
    isAuthorizedToCreate,
    isQARole,
    handleObjections,
}) {
    const [selectedDate, setSelectedDate] = useState(null);
    const [objection, setObjections] = useState({});

    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };
    const getCurrentUserRole = useSelector(getUserRoles()).filter((role) => role === "reviewer");

    useEffect(() => {
        if (newTruckData?.year) setSelectedDate(new Date(newTruckData.year, 0, 1));
    }, [newTruckData]);

    const renderObjection = (objectionName) => {
        if (objections && objections[objectionName] && isAuthorizedToCreate) {
            return <RejectionReason content={objections[objectionName]} />;
        }
        return null;
    };

    return (
        <>
            <FormRow>
                <FormGroup>
                    <Row>
                        <SelectWithSearch
                            options={allTruckClass}
                            label="Truck Class"
                            handleChange={(value) =>
                                setNewTruckData({
                                    ...newTruckData,
                                    truckClass: value,
                                })
                            }
                            isEditable={isEditable}
                            required
                            value={newTruckData?.truckClass}
                        />
                        {renderObjection("Truck Class")}
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("truckClass")}
                                handleVerify={() =>
                                    handleVerify(
                                        "truckClass",
                                        "Truck Class",
                                        "Truck Info - Truck",
                                        "truck_profile"
                                    )
                                }
                                verifed={
                                    objection?.truckClass?.verified
                                        ? objection?.truckClass?.verified
                                        : false
                                }
                                objection={
                                    objection?.truckClass?.haveobjection
                                        ? objection?.truckClass?.haveobjection
                                        : false
                                }
                            />
                        )}
                    </Row>
                    {objection?.truckClass?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Truck Class",
                                    "Truck Info - Truck",
                                    "truck_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>

                <FormGroup>
                    <Row>
                        <SelectWithSearch
                            label="Truck Type"
                            options={allBoxesType}
                            handleChange={(value) =>
                                setNewTruckData({
                                    ...newTruckData,
                                    truckType: value,
                                })
                            }
                            isEditable={isEditable}
                            required
                            value={newTruckData?.truckType}
                        />
                        {renderObjection("Truck Type")}
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("truckType")}
                                handleVerify={() =>
                                    handleVerify(
                                        "truckType",
                                        "Truck Type",
                                        "Truck Info - Truck",
                                        "truck_profile"
                                    )
                                }
                                verifed={
                                    objection?.truckType?.verified
                                        ? objection?.truckType?.verified
                                        : false
                                }
                                objection={
                                    objection?.truckType?.haveobjection
                                        ? objection?.truckType?.haveobjection
                                        : false
                                }
                            />
                        )}
                    </Row>
                    {objection?.truckType?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Truck Type",
                                    "Truck Info - Truck",
                                    "truck_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>
            <FormRow>
                <FormGroup>
                    <Row>
                        <DatePickerInput
                            label="Manufacturing Year"
                            isEditable={isEditable}
                            required
                            onChange={(value) =>
                                setNewTruckData({
                                    ...newTruckData,
                                    year: new Date(value).getFullYear(),
                                })
                            }
                            selectedValue={selectedDate}
                            showYearPicker
                            placeHolder="YYYY"
                            dateFormat="yyyy"
                            maxDate={new Date()}
                            minDate={new Date(1970, 0, 1)}
                        />
                        {renderObjection("Manufacturing Year")}
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("manufacturingYear")}
                                handleVerify={() =>
                                    handleVerify(
                                        "manufacturingYear",
                                        "Manufacturing Year",
                                        "Truck Info - Truck",
                                        "truck_profile"
                                    )
                                }
                                verifed={
                                    objection?.manufacturingYear?.verified
                                        ? objection?.manufacturingYear?.verified
                                        : false
                                }
                                objection={
                                    objection?.manufacturingYear?.haveobjection
                                        ? objection?.manufacturingYear?.haveobjection
                                        : false
                                }
                            />
                        )}
                    </Row>
                    {objection?.manufacturingYear?.haveobjection && (
                        <Textarea
                            required
                            autoFocus
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Manufacturing Year",
                                    "Truck Info - Truck",
                                    "truck_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
                <FormGroup>
                    <Row>
                        <FixedDigitsInput
                            key={newTruckData?.plateNumber}
                            fields={8}
                            label="Plate Number"
                            required
                            onChange={(value) =>
                                setNewTruckData({
                                    ...newTruckData,
                                    plateNumber: value,
                                })
                            }
                            value={newTruckData?.plateNumber}
                            type="text"
                            isArabic
                            errorMessage={plateNumberError}
                            disabled={
                                selectedTruckId && !isPlateNumberEditable ? true : !isEditable
                            }
                        />
                        {renderObjection("Plate Number")}
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("plateNumber")}
                                handleVerify={() =>
                                    handleVerify(
                                        "plateNumber",
                                        "Plate Number",
                                        "Truck Info - Truck",
                                        "truck_profile"
                                    )
                                }
                                verifed={
                                    objection?.plateNumber?.verified
                                        ? objection?.plateNumber?.verified
                                        : false
                                }
                                objection={
                                    objection?.plateNumber?.haveobjection
                                        ? objection?.plateNumber?.haveobjection
                                        : false
                                }
                            />
                        )}
                    </Row>
                    {objection?.plateNumber?.haveobjection && (
                        <Textarea
                            required
                            autoFocus
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Plate Number",
                                    "Truck Info - Truck",
                                    "truck_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>
        </>
    );
}

export default TruckInfo;
